import { render } from "./Poly.vue?vue&type=template&id=6db2414f&scoped=true"
import script from "./Poly.vue?vue&type=script&lang=js"
export * from "./Poly.vue?vue&type=script&lang=js"

import "./Poly.vue?vue&type=style&index=0&id=6db2414f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db2414f"]])

export default __exports__